import React from "react";
// import { useTranslation } from "react-i18next";
// import { useNavigate } from "react-router";


export default function PurchaseHistory() {
    // const history = useNavigate();

    // const { t } = useTranslation();

    const _content = (<>Aqui você acompanhará seu historico de compras</>)
    return _content
}
